import { memo } from "react"
import { FeedCurve } from "../../../../Services"
import { css, fonts, frames } from "../../../../Styles"
import { useFeedCurveContext } from "../../../FeedCurves/_FeedCurves/feedCurveContext";
import { useTranslation } from "react-i18next";

const LabelsMilestones = memo(({ feedCurve }: { feedCurve: FeedCurve }) => {
  const { t } = useTranslation();
  const context = useFeedCurveContext();  
  const selectedMilestone = context?.state?.milestone?.selectedMilestone;
  const dispatch = context?.dispatch;

if (feedCurve.milestones?.length === 0) return <p style={{...css.emptyPen, opacity: "0.5"}}>{t("negativeParams.milestone", {defaultValue: "No Milestone"})}</p>

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "5px", width: "fit-content"}}>
      {[...(feedCurve.milestones ?? [])].sort((milestoneA, milestoneB) => milestoneA.milestoneIndex - milestoneB.milestoneIndex).map((feedcurveMilestone, index) => {
        const _isHovered = selectedMilestone === feedcurveMilestone

        return (
          <frames.TextLabel
            key={index}
            $isHovered={_isHovered}
            onMouseEnter={() => dispatch({ milestone: { selectedMilestone: feedcurveMilestone } })}
            onMouseLeave={() => dispatch({ milestone: { selectedMilestone: undefined} })}
            style={{gap: "2px"}}
          >
            <p style={{ ...fonts.header }}>{`M${index + 1}: `}</p>
            <p style={{ ...fonts.paragraph, lineHeight: "1" }}>{`${feedcurveMilestone.name}`}</p>
          </frames.TextLabel>
        )
      })}
    </div>
  )
})

export default LabelsMilestones